require('vendor/modernizr');
require('vendor/detectizr');

import 'shared/polyfill';
import { forEach, capitalize } from 'lodash';
import Tooltip from 'tooltip.js';

// Shared
import ScrollingHero from 'shared/scrollingHero';
import JustifiedGallery from 'shared/justifiedGallery';
import Sticky from 'shared/sticky';
import Clickable from 'shared/clickable';
import GridCarousel from 'shared/gridCarousel';
import Links from 'shared/links';
import Slider from 'shared/slider';
import Share from 'shared/share';
import Focus from 'shared/focus';
import Dropdown from 'shared/dropdown';
import Video from 'shared/video';
import FakeSelect from 'shared/fakeSelect';
import Gallery from 'shared/gallery';
import Accordion from 'shared/accordion';
import TabNavigation from 'shared/tabNavigation';
import CoursesHeader from 'shared/coursesHeader';
import Sidebar from 'shared/sidebar';
import Map from 'shared/map';
import SelectRedirect from 'shared/selectRedirect';
import Onboarding from 'shared/onboarding';
import TableResults from 'shared/tableResults';
import Calendar from 'shared/calendar';
import AgendaSchedule from 'shared/agendaSchedule';
import CoursesToggle from 'shared/coursesToggle';
import HomeOnboarding from 'shared/homeOnboarding';
import Parallaxable from 'shared/parallaxable';
import Experience from 'shared/experience';
import FullscreenPicture from 'shared/fullscreenPicture';
import MosaicOverlayer from 'shared/mosaicOverlayer';

// Views
import Nav from 'view/nav/nav';
import Search from 'view/search';
import HomeVideo from 'view/homeVideo';
import Quizz from 'view/quizz';

const classes = {
  Slider,
  Video,
};

window.applyComponent = function (name, els) {
  if (!classes[capitalize(name)]) {
    return false;
  }

  forEach(els, (el) => new classes[capitalize(name)](el));
};

if (document.querySelector('.topbar')) {
  document.documentElement.classList.add('with-topbar');
}

class ULiege {
  constructor() {
    ULiege.domReady().then(this.ready.bind(this));
    // this.ready();
  }

  ready() {
    this.applyScrollingHero();
    this.applyJustifiedGallery();
    this.applyStickyHeader();
    this.applyClickable();
    this.applyGridCarousel();
    this.applyLinks();
    this.applySlider();
    this.applyShare();
    this.applyFocus();
    this.applyDropdown();
    this.applyVideo();
    this.applyFakeSelect();
    this.applyGallery();
    this.applyAccordion();
    this.applyTabNavigation();
    // this.applyCoursesHeader();
    this.applySidebar();
    this.applyMap();
    this.applySelectRedirect();
    this.applyOnboarding();
    this.applyTableResults();
    this.applyTests();
    this.applyTooltip();

    this.applyNav();
    this.applySearch();
    this.applyHomeVideo();
    this.applyCalendar();
    this.applyAgendaSchedule();
    this.applyCoursesToggle();
    this.applyHomeOnboarding();
    this.applyParallaxable();
    this.applyExperience();
    this.applyFullscreenPicture();
    this.applyMosaicOverlayer();

    this.applyQuizz();
  }

  applyScrollingHero() {
    const el = document.querySelector('[data-component="scrolling-hero"]');

    if (!el) {
      return;
    }

    new ScrollingHero(el);
  }

  applyJustifiedGallery() {
    const els = document.querySelectorAll(
      '[class*="u-mosaic-gallery--"][class*="--justified"]'
    );

    forEach(els, (el) => {
      new JustifiedGallery(el);
    });
  }

  applyParallaxable() {
    const els = document.querySelectorAll('[data-component="parallaxable"]');

    forEach(els, (el) => {
      new Parallaxable(el);
    });
  }

  applyHomeOnboarding() {
    const el = document.querySelector('[data-component="home-onboarding"]');

    new HomeOnboarding(el);
  }

  applyNav() {
    this.nav = new Nav(this.sticky.hasSticky);
  }

  applySearch() {
    const togglers = document.querySelectorAll('[href$="#search"]');

    forEach(togglers, (link) => {
      new Search(link);
    });
  }

  applyClickable() {
    new Clickable();
  }

  applyGridCarousel() {
    const els = document.querySelectorAll('.u-grid-cards--carousel');
    forEach(els, (el) => new GridCarousel(el));
  }

  applySlider() {
    const els = document.querySelectorAll('.u-slider');
    forEach(els, (el) => new Slider(el));
  }

  applyShare() {
    new Share();
  }

  applyLinks() {
    new Links();
  }

  /*
    Make sure that focus component is initialised
    after 'Slider', because it needs the instance of the slider.
  */
  applyFocus() {
    const els = document.querySelectorAll('.u-focus');
    forEach(els, (el) => new Focus(el));
  }

  applyDropdown() {
    const els = document.querySelectorAll('[data-dropdown]');
    forEach(els, (el) => new Dropdown(el));
  }

  applyVideo() {
    const els = document.querySelectorAll(
      '[class*="u-card--"][class*="--video"]'
    );
    forEach(els, (el) => new Video(el));
  }

  applyFakeSelect() {
    const els = document.querySelectorAll('.u-fake-select');
    forEach(els, (el) => new FakeSelect(el));
  }

  applyGallery() {
    const els = document.querySelectorAll('.u-gallery');
    forEach(els, (el) => new Gallery(el));
  }

  applyAccordion() {
    const els = document.querySelectorAll('[data-accordion-toggler]');
    forEach(els, (el) => new Accordion(el));
  }

  applyTabNavigation() {
    const els = document.querySelectorAll('[data-nav-tab]');
    forEach(els, (el) => new TabNavigation(el));
  }

  applyTests() {
    // mix-blend-mode
    if ('CSS' in window && 'supports' in window.CSS) {
      var support = window.CSS.supports('mix-blend-mode', 'multiply');
      support = support ? 'mix-blend-mode' : 'no-mix-blend-mode';
      document.documentElement.classList.add(support);
    }
  }

  applyTooltip() {
    const els = document.querySelectorAll('[data-tooltip]');
    forEach(
      els,
      (el) =>
        new Tooltip(el, {
          placement: 'top',
          title: () => {
            const str = el.dataset.tooltip;
            const parts = str.split('/');
            const html = `<strong>${parts[0]}</strong><span>${parts[1]}</span>`;
            return html;
          },
          html: true,
        })
    );
  }

  applyCoursesHeader() {
    const el = document.querySelector('.u-courses-header');

    if (!el) {
      return;
    }

    new CoursesHeader(el);
  }

  applyStickyHeader() {
    this.sticky = new Sticky();
  }

  applyMap() {
    const els = document.querySelectorAll('.u-map');
    forEach(els, (el) => new Map(el));
  }

  applySelectRedirect() {
    const els = document.querySelectorAll('[data-select-redirect]');
    forEach(els, (el) => new SelectRedirect(el));
  }

  applySidebar() {
    const el = document.querySelector('.u-sidebar-inner');

    if (!el) {
      return;
    }

    new Sidebar(el);
  }

  applyHomeVideo() {
    const el = document.querySelector('[data-home-video]');

    new HomeVideo(el);
  }

  applyCalendar() {
    const el = document.querySelector('[data-article-calendar]');

    new Calendar(el);
  }

  applyAgendaSchedule() {
    const els = document.querySelectorAll('[data-agenda-schedule-item]');

    if (!els.length) {
      return;
    }

    forEach(els, (el) => new AgendaSchedule(el));
  }

  applyCoursesToggle() {
    const els = document.querySelectorAll('[data-courses-toggle]');

    if (!els.length) {
      return;
    }

    forEach(els, (el) => new CoursesToggle(el));
  }

  applyOnboarding() {
    // const el = document.querySelector('.u-homepage .u-card--full, .u-homepage .u-card--hero, .u-uliege .u-card--full, .u-uliege .u-card--hero');
    const el = document.querySelector('.u-card--full, .u-card--hero');

    if (!el) {
      return;
    }

    new Onboarding(el);
  }

  applyTableResults() {
    new TableResults();
  }

  applyExperience() {
    const el = document.querySelector('[data-experience]');

    if (!el) {
      return;
    }

    new Experience(el);
  }

  applyFullscreenPicture() {
    const els = document.querySelectorAll(
      '.u-mosaic__picture-container[data-fullscreen]'
    );
    forEach(els, (el) => new FullscreenPicture(el));
  }

  applyMosaicOverlayer() {
    const els = document.querySelectorAll('[data-mosaic-overlayer="true"]');

    if (!els.length) {
      return;
    }

    forEach(els, (el) => new MosaicOverlayer(el));
  }

  applyQuizz() {
    const el = document.querySelector('[data-quizz]');

    if (!el) {
      return;
    }

    new Quizz(el);
  }

  static domReady() {
    return new Promise((resolve) => {
      document.addEventListener('DOMContentLoaded', resolve);
    });
  }
}

new ULiege();
